<template>
	<section class="iLoadingBox">
		<a-spin :tip="message" class="content" size="large" />
		<transition name="dialog">
			<div v-if="isShow" class="shade" @click="shadeOnClick()"></div>
		</transition>
	</section>
</template>

<script>
	export default {
		props: {
			// 加载提示语
			message: {
				type: String,
				default: 'Loading...'
			},
			// 点击遮罩是否关闭
			closeModal: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				isShow: false
			}
		},
		methods: {
			render(options) {
				this.isShow = true;
				Object.assign(this.$props, options)
			},
			shadeOnClick() {
				if(this.closeModal) {
					this.isShow = false;
					this.$emit('onClose');
				}
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.iLoadingBox {
		z-index: 30000;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: Microsoft YaHei, simhei, Tahoma, Arial, sans-serif !important;
		.content {
			z-index: 31000;
			box-sizing: border-box;
			position: fixed;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			transition: opacity 0.3s, transfrom 0s, top 0.3s;
			backface-visibility: hidden;
			-webkit-backface-visibility: hidden;
			position: fixed;
		}
		.shade {
			z-index: 30000;
			position: fixed;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
			background: #000;
			-moz-opacity: 0.5;
			opacity: 0.50;
			filter: alpha(opacity=70);
		}
		.dialog-enter-active {
			animation: dialog-show 0.1s;
		}
		.dialog-leave-active {
			animation: dialog-hide 0.3s;
		}
		@keyframes dialog-show {
			from {
				opacity: 0;
			}
			to {
				opacity: 0.5;
			}
		}
		@keyframes dialog-hide {
			from {
				opacity: 0.5;
			}
			to {
				opacity: 0;
			}
		}
	}
</style>